import PlayerState from './PlayerState';
import { defaultValue } from './helpers';
class LoadStatus {
    constructor(progress = 0.0, bytesDownloaded = 0.0) {
        this.bytesDownloaded = bytesDownloaded;
        this.completionTime = undefined;
        this.progress = progress;
    }
    get complete() {
        return this.progress >= 1.0;
    }
    get progress() {
        return this._progress;
    }
    set progress(value) {
        if (value >= 1.0)
            this.completionTime = Date.now();
        this._progress = value;
    }
}
const defaultState = {
    playerState: PlayerState.INITIALIZING,
    progress: 0.0,
    userEngaged: new LoadStatus(),
    scene: new LoadStatus(),
    globeReady: new LoadStatus(),
    sceneTiles: new LoadStatus(),
    tracks: {},
    trackReadyTimes: {},
};
export function loadingReducer(state = defaultState, action) {
    switch (action.type) {
        case 'UPDATE_LOADING_PROGRESS': {
            const newState = Object.assign({}, state);
            const load = newState[action.key];
            load.progress = action.progress;
            newState.progress = getLoadingProgress(newState);
            return newState;
        }
        case 'UPDATE_TRACK_LOADING_PROGRESS': {
            const newState = Object.assign(Object.assign({}, state), { tracks: Object.assign({}, state.tracks) });
            const oldLoad = defaultValue(state.tracks[action.trackId], new LoadStatus());
            const newLoad = new LoadStatus(defaultValue(action.progress, oldLoad.progress), defaultValue(action.bytesDownloaded, oldLoad.bytesDownloaded));
            newState.tracks[action.trackId] = newLoad;
            newState.progress = getLoadingProgress(newState);
            return newState;
        }
        case 'SET_USER_ENGAGED': {
            return Object.assign(Object.assign({}, state), { userEngaged: new LoadStatus(1.0) });
        }
        case 'SET_PLAYER_STATE': {
            return Object.assign(Object.assign({}, state), { playerState: action.state });
        }
        case 'SET_TRACK_READY_TIME': {
            const newState = Object.assign(Object.assign({}, state), { trackReadyTimes: Object.assign({}, state.trackReadyTimes) });
            newState.trackReadyTimes[action.trackId] = action.readyTime;
            newState.progress = getLoadingProgress(newState);
            newState.sceneReadyTime = Infinity;
            const trackKeys = Object.keys(newState.trackReadyTimes);
            for (let i = 0; i < trackKeys.length; i++) {
                const k = trackKeys[i];
                newState.sceneReadyTime = Math.min(newState.sceneReadyTime, newState.trackReadyTimes[k]);
            }
            return newState;
        }
        default:
            return state;
    }
}
function getLoadingProgress(loading) {
    if (loading.playerState < PlayerState.LOADING)
        return 0;
    // Count the number of tracks that have at least one point
    // @TODO: We may want to consider activity.waitUntilReady here
    let readyCount = 0;
    const trackCount = Object.keys(loading.trackReadyTimes).length;
    Object.keys(loading.trackReadyTimes).forEach(tid => {
        if (loading.trackReadyTimes[tid] > 0.0)
            readyCount += 1;
    });
    const tilePercent = loading.sceneTiles.progress;
    const trackPercent = trackCount > 0 ? readyCount / trackCount : 1.0;
    const trackWeight = Math.min(trackCount / 16, 1.0) * 0.5;
    return tilePercent * (1.0 - trackWeight) + trackPercent * trackWeight;
}
export default class LoadingManager {
    update(app, state, globe, dispatch) {
        if (state.loading.playerState === PlayerState.INITIALIZING) {
            if (state.loading.scene.complete && state.loading.globeReady.complete) {
                app.onPlayerReady();
                dispatch({ type: 'SET_PLAYER_STATE', state: PlayerState.START_SCREEN });
            }
        }
        else if (state.loading.playerState === PlayerState.START_SCREEN) {
            if (state.scene.sceneSettings.autoplay || state.loading.userEngaged.complete) {
                app.onPlayerStart();
                dispatch({ type: 'SET_PLAYER_STATE', state: PlayerState.LOADING });
            }
        }
        else if (state.loading.playerState === PlayerState.LOADING) {
            dispatch({ type: 'UPDATE_LOADING_PROGRESS', key: 'sceneTiles', progress: globe.getTileLoadingProgress() });
            if (state.loading.progress >= 1.0) {
                app.onPlayerPlaying();
                dispatch({ type: 'SET_PLAYER_STATE', state: PlayerState.PLAYING });
            }
        }
    }
}
